import Vue from 'vue';
import merge from 'lodash/merge';

/**
 * LogsService
 */
class LogsService
{
    static async getChangeLog(filter, pager)
    {
        return Vue.axios.get('admin/logs/changelog', {
            params: merge({}, filter, pager.data())
        });
    }

    static async getChangeDiff(id)
    {
        return Vue.axios.get(`admin/logs/changelog/${id}`);
    }

    static async GetModelTypes()
    {
        return Vue.axios.get(`admin/logs/models`);
    }
}

export default LogsService;

// export interface AuthListItemModel
// {
//     id: number;
//     dateCreatedUtc: DateTime;
//     dateExpiredUtc?: DateTime;
//     userId: number;
//     userName: string;
//     ipAddress: string;
//     result: string;
// }

// export interface AuthFilterModel
// {
//     userName: string;
//     ipAddress: string;
//     dateFromUtc?: DateTime;
//     dateDueUtc?: DateTime;
//     result?: string;
// }

// export interface ChangesModel
// {
//     id: number;
//     author: AuthorModel;
//     session: SessionModel;
//     operationDateUtc: DateTime;
//     objectType: string;
//     objectId: string;
//     operationType: EntityState;
//     changes: Diff[];
// }

// export interface ChangesListItemModel
// {
//     id: number;
//     author: AuthorModel;
//     session: SessionModel;
//     operationDateUtc: DateTime;
//     objectType: string;
//     objectId: string;
//     operationType: EntityState;
// }

// export interface ChangesFilterModel
// {
//     sessionId?: number;
//     userName: string;
//     ipAddress: string;
//     dateFromUtc?: DateTime;
//     dateDueUtc?: DateTime;
//     objectType?: string;
//     objectId: number;
//     operationType?: EntityState;
// }

// export interface AuthorModel
// {
//     id: number;
//     userName: string;
//     givenName: string;
//     surname: string;
//     email: string;
//     facePictureUrl: string;
// }

// export interface SessionModel
// {
//     id: number;
//     ipAddress: string;
//     result: string;
//     dateCreatedUtc: DateTime;
//     dateExpiredUtc?: DateTime;
// }
